import { render, staticRenderFns } from "./pardakht-shakhsi.vue?vue&type=template&id=5589aaa8&scoped=true&"
import script from "./pardakht-shakhsi.vue?vue&type=script&lang=js&"
export * from "./pardakht-shakhsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589aaa8",
  null
  
)

export default component.exports